var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 36,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0165 14.326C13.3751 13.9278 15.2943 12.0787 15.3693 12.0076C15.5492 11.8226 15.8191 11.7373 16.074 11.7515C16.2839 11.7657 16.4788 11.8653 16.6287 12.0076C16.6437 12.0218 18.5629 13.9136 21.9665 14.326C22.4313 14.3829 22.7912 14.7812 22.7462 15.2222C22.1914 22.5475 16.5988 25.0793 16.3589 25.1789C16.2389 25.2358 16.119 25.25 15.999 25.25C15.8791 25.25 15.7441 25.2216 15.6392 25.1789C15.3993 25.0793 9.80659 22.5475 9.25182 15.2079C9.22183 14.7812 9.56669 14.3829 10.0165 14.326Z",
    fill: "#48D38A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.6261f9c94697bcdc45950e30187138d0.svg";
export { ForwardRef as ReactComponent };